import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import ShopInterface from '../../api/ShopInterface';
import Screens from '..';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants, { PurchaseTypes } from '../../utils/routeParamConstants';
import { rewardTypes } from '../../utils/messageTypes';
import { PLATFORM } from '../../constants';
import utils from '../../utils';
import { getText, TEXT_KEY } from '../../utils/localization';
import AppInterface from '../../api/AppInterface';

var PurchaseSucceeded = /*#__PURE__*/function (_Component) {
  _inherits(PurchaseSucceeded, _Component);

  var _super = _createSuper(PurchaseSucceeded);

  function PurchaseSucceeded() {
    var _this;

    _classCallCheck(this, PurchaseSucceeded);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.goToVipLobbyHandler = function () {
      _this.props.dismissModal();

      _this.props.showVipAccessModal(false); // setting it to false to stop showing the pop up again.


      ShopInterface.refreshActiveConsumables();
      QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, undefined));
      QueryParamsProxy.navigate(_this.props.navigation, Screens.VIP);
    };

    _this.closeModal = function () {
      _this.props.dismissModal();

      _this.props.showVipAccessModal(true); // setting it back to true to show the pop up again.

    };

    _this.getActiveRouteName = function () {
      var navigationState = _this.props.navigation.state;
      if (utils.getPlatform() === PLATFORM.WEB) return navigationState.routes[navigationState.index].routeName;
      return navigationState.routeName;
    };

    return _this;
  }

  _createClass(PurchaseSucceeded, [{
    key: "componentWillUnmount",
    value: function () {
      var _componentWillUnmount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.getActiveRouteName() === Screens.Home)) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return AppInterface.updateAppEvents();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentWillUnmount() {
        return _componentWillUnmount.apply(this, arguments);
      }

      return componentWillUnmount;
    }()
  }, {
    key: "render",
    value: function render() {
      var purchaseType = this.props.purchaseType;
      var vipPurchase = purchaseType === PurchaseTypes.VIP || purchaseType === rewardTypes.VIP_ROOM_ACCESS || purchaseType === PurchaseTypes.CONSUMABLE;
      var message;
      var buttonHandler;

      if (vipPurchase) {
        message = getText(TEXT_KEY.ENJOY_EXCLUSIVE_COLLECTION_MESSAGE);
        buttonHandler = this.goToVipLobbyHandler;
      } else {
        message = getText(TEXT_KEY.COINS_HAVE_BEEN_ADDED_MESSAGE);
        buttonHandler = this.closeModal;
      }

      return this.props.render({
        message: message,
        buttonHandler: buttonHandler,
        vipPurchase: vipPurchase
      });
    }
  }]);

  return PurchaseSucceeded;
}(Component);

export { PurchaseSucceeded as default };